import React, { useRef, useState }          from 'react';
import { Button, Col, Form, Modal, Row }    from 'react-bootstrap';
import { useDispatch }                      from 'react-redux';
import { Formik }                           from 'formik';
import moment                               from 'moment';
import * as yup                             from 'yup';

import { ICON_SAVE, ICON_CANCEL }           from '../../../../extras/icons';
import { updateScheduledEndAction }         from '../../../../../actions/audiencesActions';

import ButtonSpinner                        from '../../../../layout/ButtonSpinner'




const FinProgramadoForm = props => {



    // ---------------------------------------------------------------------------------------------------------------------
    // DECLARACIONES -------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    // Tomo los props
    const { show, handleClose, audience } = props;

    // Genero los ref
    const refFecha = useRef();
    const refHoraInicio = useRef();
    const refHoraFin = useRef();

    // Inicializo datos
    const initialData = {
        fecha: audience && audience.inicio ? moment(audience.inicio).format('YYYY-MM-DD') : '',
        horaInicio: audience && audience.inicio ? moment(audience.inicio).format('HH:mm') : '',
        horaFin: audience && audience.fin ? moment(audience.fin).format('HH:mm') : '',
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [loading, setLoading] = useState(false);



    // ---------------------------------------------------------------------------------------------------------------------
    // FUNCIONES -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------

    // Manejo cuando se muestra
    const handleOnShow = e => {
        // Pongo el foco en el primer campo
        refFecha.current.focus();
    }

    // Manejo el guardado
    const handleSave = async values => {
        setLoading(true);
        // Armo los datos
        let inicio = values.fecha + ' ' + values.horaInicio;
        let fin = values.fecha + ' ' + values.horaFin;
        const data = {
            inicio: moment(inicio).format('YYYY-MM-DD HH:mm:ss'),
            fin: moment(fin).format('YYYY-MM-DD HH:mm:ss'),
        }
        // Llamo al dispatch
        dispatch( updateScheduledEndAction(audience, data, handleClose) );
        setLoading(false);
    }

    // Esquema de validación
    const validationSchema = yup.object({
        fecha: yup.date().required('La fecha es obligatoria'),
        horaInicio: yup.string().required('La hora de inicio es obligatoria'),
        horaFin: yup
            .string()
            .required('La hora de fin es obligatoria')
            .test(
                'es-mayor',
                'La hora de fin debe ser posterior a la hora de inicio',
                function (horaFin) {
                    const { horaInicio } = this.parent;
                    if (!horaInicio || !horaFin) return true;
                    return moment(horaFin, 'HH:mm').isAfter(moment(horaInicio, 'HH:mm'));
                }
            ),
    });



    // ---------------------------------------------------------------------------------------------------------------------
    // RENDERIZO -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    return (
        <Modal
            centered 
            onHide = { handleClose } 
            onShow = { handleOnShow }
            show = { show }
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Horario Programado <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <Row>
                                <Col xs="12">
                                    <div className="alert alert-info">
                                        Seleccione la Fecha y Horas Programadas de la Audiencia.
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" sm="4">
                                    <Form.Label>
                                        Seleccione la Fecha
                                    </Form.Label>
                                    <Form.Control
                                        className = "form-control"
                                        disabled = { loading }
                                        id = "fecha"
                                        isInvalid = { !!errors.fecha && touched.fecha }
                                        name = "fecha"
                                        onChange = { handleChange }
                                        placeholder = "Seleccione la Fecha"
                                        ref = { refFecha }
                                        type = "date"
                                        value = { values.fecha }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Col>
                                <Col xs="12" sm="4">
                                    <Form.Label>
                                        Hora de Inicio Programado
                                    </Form.Label>
                                    <Form.Control
                                        className = "form-control"
                                        disabled = { loading }
                                        id = "horaInicio"
                                        isInvalid = { !!errors.horaInicio && touched.horaInicio }
                                        name = "horaInicio"
                                        onChange = { handleChange }
                                        placeholder = "Seleccione la Hora de Inicio"
                                        ref = { refHoraInicio }
                                        type = "time"
                                        value = { values.horaInicio }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaInicio }
                                    </Form.Control.Feedback>
                                </Col>
                                <Col xs="12" sm="4">
                                    <Form.Label>
                                        Hora de Fin Programado
                                    </Form.Label>
                                    <Form.Control
                                        className = "form-control"
                                        disabled = { loading }
                                        id = "horaFin"
                                        isInvalid = { !!errors.horaFin && touched.horaFin }
                                        name = "horaFin"
                                        onChange = { handleChange }
                                        placeholder = "Seleccione la Hora de Finalización"
                                        ref = { refHoraFin }
                                        type = "time"
                                        value = { values.horaFin }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.horaFin }
                                    </Form.Control.Feedback>
                                </Col>
                            </Row>
                    </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ loading }>
                                            <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default FinProgramadoForm;